/**
 * Shared currency formatting for the dashboard.
 *
 * Always renders 2 decimal places (e.g. "161.50", "0.00").
 * Does NOT include the "$" prefix — callers add that inline
 * so template literals like `~$${formatCurrency(fee)}` stay readable.
 */
export function formatCurrency(amount: number): string {
  return amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
